import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import CenterHorizontal from 'packages/kakapo-ui-kit/components/atoms/CenterHorizontal';
import { SectionTitle, SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';

export default function ForgotPassword() {
    const { t } = useTranslation();

    return (
        <BareLayout>
            <Formik initialValues={{}} onSubmit={() => { }}>
                {({ isSubmitting }) => (
                    <PublicForm>
                        <CenterHorizontal>
                            <SubSectionTitle>
                                {t('common.checkInbox.success.subtitle')}
                            </SubSectionTitle>
                            <Box my={2} />
                            <SectionTitle>{t('common.checkInbox.success.title')}</SectionTitle>
                            <Box my={4} />
                            <Paragraph>
                                {t('common.checkInbox.success.message')}
                            </Paragraph>
                        </CenterHorizontal>
                    </PublicForm>
                )}
            </Formik>
        </BareLayout>
    );
}
